import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowRightIcon, Button } from '../../../components';
import { useNextTask } from '../utils/hooks';
import { getStateSealImage } from '../../../utils/seals';
import { USStateAbbrev } from '../../../constants';
import { LOCATION_CODE_TO_NAME } from '../../../utils/locations';

export const ResolverIntroSetup = () => {
  const nextTask = useNextTask();
  const { locationId } = useParams();

  if (!nextTask || !locationId) {
    return <Navigate to="/tasks/resolver" replace />;
  }

  const name = LOCATION_CODE_TO_NAME[locationId.toUpperCase()];

  return (
    <div className="flex flex-col items-center gap-y-6">
      <img
        src={getStateSealImage(locationId as USStateAbbrev)}
        className="mb-3 size-24"
        alt={`${name} state seal`}
      />
      <h1 className="text-4xl font-bold">{name} State Setup</h1>
      <p className="max-w-80 text-center">
        Share more about your business and get set up in {name}.
      </p>

      <Button
        as={Link}
        to={`task/${nextTask.id}`}
        size="xlarge"
        rightIcon={<ArrowRightIcon className="size-4" />}
      >
        Get Started
      </Button>
    </div>
  );
};
